import type { BoxProps } from "@mui/material";
import { useTheFooterProps } from "./fetch";
import { TheFooter as TheFooterUI } from "./ui/TheFooter";

export const TheFooter = (props: BoxProps) => {
  const footerProps = useTheFooterProps();
  return <TheFooterUI {...footerProps} {...props} />;
};
